// Representative sample data for the PBX Analytics & Reporting dashboard (front-end demo).

export const kpis = {
  totalCalls: 1284, answered: 1131, missed: 153, answerRate: 88,
  avgTalk: "3:42", totalMinutes: 4820, inbound: 812, outbound: 472,
};

// Bell-ish hourly curve (0-23)
export const callsByHour = Array.from({ length: 24 }, (_, h) => {
  const peak = Math.exp(-Math.pow((h - 15) / 4, 2)) + 0.6 * Math.exp(-Math.pow((h - 11) / 3, 2));
  return { h: `${h}`, v: Math.round(peak * 120 + (h > 7 && h < 21 ? 8 : 1)) };
});

export const daily30 = Array.from({ length: 30 }, (_, d) => ({
  d: `${d + 1}`,
  v: Math.round(140 + 60 * Math.sin(d / 3) + (d % 7 === 0 ? -50 : 0) + (d % 5) * 6),
}));

export const topCallers = [
  { id: "+91 98200 11234", calls: 148 }, { id: "+91 80471 82210", calls: 121 },
  { id: "+1 415 555 0132", calls: 96 }, { id: "+44 20 7946 0991", calls: 74 },
  { id: "+91 22 6150 9900", calls: 58 },
];
export const topDest = [
  { id: "Sales queue", calls: 312 }, { id: "Support queue", calls: 268 },
  { id: "Ext. 104 · Priya", calls: 141 }, { id: "IVR · Main menu", calls: 119 },
  { id: "AI Agent · Inbound", calls: 97 },
];

export const byTenant = [
  { name: "Acme Corp", calls: 486, answered: 441, missed: 45, rate: 91 },
  { name: "Globex Ltd", calls: 342, answered: 296, missed: 46, rate: 87 },
  { name: "Umbrella Inc", calls: 268, answered: 233, missed: 35, rate: 87 },
  { name: "Initech", calls: 188, answered: 161, missed: 27, rate: 86 },
];

export const agents = [
  { name: "Priya Sharma", ext: "104", calls: 142, answered: 136, avgTalk: "3:12", rating: 96 },
  { name: "Arjun Mehta", ext: "108", calls: 128, answered: 119, avgTalk: "4:02", rating: 91 },
  { name: "Meera Nair", ext: "112", calls: 117, answered: 110, avgTalk: "2:48", rating: 94 },
  { name: "Rahul Verma", ext: "119", calls: 98, answered: 88, avgTalk: "3:36", rating: 88 },
  { name: "Sana Khan", ext: "121", calls: 86, answered: 80, avgTalk: "3:05", rating: 92 },
];

export const cdrs = [
  { time: "14:32:10", from: "+91 98200 11234", to: "Sales queue", dir: "Inbound", dur: "4:12", status: "Answered" },
  { time: "14:28:47", from: "Ext. 104", to: "+91 80471 82210", dir: "Outbound", dur: "2:05", status: "Answered" },
  { time: "14:19:03", from: "+1 415 555 0132", to: "Support queue", dir: "Inbound", dur: "0:00", status: "Missed" },
  { time: "14:07:55", from: "AI Agent", to: "+91 22 6150 9900", dir: "Outbound", dur: "1:48", status: "Answered" },
  { time: "13:58:21", from: "+44 20 7946 0991", to: "IVR · Main", dir: "Inbound", dur: "3:31", status: "Answered" },
  { time: "13:44:09", from: "+91 90040 55321", to: "Ext. 112", dir: "Inbound", dur: "0:00", status: "Missed" },
  { time: "13:30:58", from: "Ext. 108", to: "+91 70210 99881", dir: "Outbound", dur: "5:20", status: "Answered" },
];

export const sessions = [
  { agent: "Priya Sharma", login: "09:02", logout: "18:11", online: "9h 09m" },
  { agent: "Arjun Mehta", login: "09:15", logout: "18:04", online: "8h 49m" },
  { agent: "Meera Nair", login: "08:58", logout: "17:46", online: "8h 48m" },
  { agent: "Rahul Verma", login: "09:31", logout: "18:20", online: "8h 49m" },
];

export const breaks = [
  { agent: "Priya Sharma", breaks: 3, total: "42m", longest: "18m" },
  { agent: "Arjun Mehta", breaks: 4, total: "56m", longest: "22m" },
  { agent: "Meera Nair", breaks: 2, total: "31m", longest: "16m" },
  { agent: "Rahul Verma", breaks: 3, total: "48m", longest: "20m" },
];

export const missed = [
  { time: "14:19:03", caller: "+1 415 555 0132", did: "+91 80 4718 2210", waited: "0:38" },
  { time: "13:44:09", caller: "+91 90040 55321", did: "+91 80 4718 2211", waited: "0:52" },
  { time: "12:51:44", caller: "+91 98111 22019", did: "+91 22 6150 9900", waited: "1:07" },
  { time: "11:37:22", caller: "+44 20 7946 0991", did: "+91 80 4718 2210", waited: "0:44" },
];

export const didTraffic = [
  { did: "+91 80 4718 2210", inbound: 214, outbound: 132 },
  { did: "+91 22 6150 9900", inbound: 168, outbound: 88 },
  { did: "+1 415 555 0100", inbound: 96, outbound: 141 },
  { did: "+44 20 7946 0100", inbound: 74, outbound: 52 },
];

export const callDuration = [
  { range: "0–30s", v: 186 }, { range: "30s–1m", v: 242 }, { range: "1–3m", v: 358 },
  { range: "3–5m", v: 274 }, { range: "5–10m", v: 148 }, { range: "10m+", v: 76 },
];

export const queues = [
  { name: "Sales", waiting: 3, avgWait: "0:34", sla: 92, agents: 6 },
  { name: "Support", waiting: 5, avgWait: "0:58", sla: 84, agents: 8 },
  { name: "Billing", waiting: 1, avgWait: "0:21", sla: 96, agents: 3 },
];

export const voicemails = [
  { time: "14:02", caller: "+91 98200 11234", did: "Sales", dur: "0:38" },
  { time: "12:47", caller: "+91 90040 55321", did: "Support", dur: "1:12" },
  { time: "11:20", caller: "+44 20 7946 0991", did: "Billing", dur: "0:52" },
];

// 7 days x 24 hours heat matrix (0-100 intensity)
export const heatmap = Array.from({ length: 7 }, (_, day) =>
  Array.from({ length: 24 }, (_, h) => {
    const base = Math.exp(-Math.pow((h - 14) / 5, 2)) * 100;
    const weekend = day >= 5 ? 0.4 : 1;
    return Math.round(base * weekend * (0.7 + ((day * 7 + h) % 5) * 0.08));
  })
);
export const heatDays = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
